'use strict';
export default function routes($stateProvider) {
    'ngInject';
    $stateProvider
        .state('cart', {
        url: '/cart/checkout?cartId',
        template: require('./checkout/checkout.html'),
        params: {
            cartId: null
        }
    })
        .state('shippingAndDelivery', {
        url: '/cart/checkout/shipping-and-delivery?cartId',
        template: require('./checkout/shipping-and-delivery/shipping-and-delivery.html'),
        params: {
            referrer: 'None',
            cartId: null
        },
    })
        .state('payment', {
        url: '/cart/checkout/payment?cartId',
        template: '<payment></payment>',
        params: {
            cartId: null
        }
    })
        .state('reviewOrder', {
        url: '/cart/checkout/review-order?cartId',
        template: '<review-order></review-order>',
        params: {
            cartId: null
        }
    })
        .state('placedOrder', {
        url: '/cart/checkout/thankyou',
        template: '<thankyou></thankyou>',
        params: { isAkrisOrder: false }
    });
}
//# sourceMappingURL=cart.routes.js.map